import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const auth = useSelector((s) => s.auth);
  if (!auth.hydrated) return null;
  if (!auth.isAuthenticated) return <Navigate to="/" replace />;
  return children;
}

export default ProtectedRoute;
